import { t } from "../../../hooks/useAppTranslation";
import {useEffect, useState} from 'react';
import {createPortal} from 'react-dom';

import PopUp from '../../PopUp/PopUp';
import {DocumentOnList} from '../DocumentOnList/DocumentOnList';
import {withDocumentsList} from '../hoc/withDocumentsList';


const $MODAL_CONTAINER = document.getElementById('modal-root');


const BaseSimpleDocumentsListWithFetch = ({
                                            documents: originalDocuments,
                                            fetchError,
                                            fetchingOn,
                                            inPopup,
  onCancel  // this one is needed if inPopup
}) => {
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    // at the beginning, the list can be empty
    setDocuments(originalDocuments || []);
  }, [originalDocuments]);

  let content;
  if (fetchingOn) {
    content = <p className="info-text" role="status">{t('external-controls-loading-file-list')}</p>;
  } else if (fetchError) {
    content =
      <p className="error-text" role="alert">
        {t('external-controls-failed-load-file-list')} {fetchError}
      </p>;
  } else {
    content = (
      <>
        {documents.length > 0
          ? documents.map(document =>
            <DocumentOnList document={document} key={document.id} />
          ) : <p className="info-text" role="status">{t('external-controls-file-list-empty')}</p>
        }
        {inPopup &&
          <div className='btn_group mb-2'>
            <button className='btn save-btn' onClick={onCancel}>{t('g-ok')}</button>
          </div>
        }
      </>
    )
  }

  if (inPopup) {
    return createPortal(
      <PopUp
          className="documents"
          customContent
          notification=""
          title={t('g-files')}
          handleClosePopup={fetchingOn ? null : onCancel}
          scrolled
      >
        {content}
      </PopUp>,
        $MODAL_CONTAINER
    )
  }

  return content
};

export const SimpleDocumentsListWithFetch = withDocumentsList(
  BaseSimpleDocumentsListWithFetch);
